export default __webpack_public_path__ + "static/Nunito-Medium-97020b1bfe8c41a3bd4efa0b910db98e.ttf";